import React from 'react';
import {
  makeStyles,
  useMediaQuery,
  useTheme,
  IconButton
} from '@material-ui/core';

import { colorSet } from '@components/Provider';
import { useHistory } from 'react-router-dom';
import { CustomizedTypography } from '@components/Customized';
import ReviewTabs from './ReviewTabs';
import { ChevronLeftOutlined } from '@material-ui/icons';
import { ReviewType } from './types';
import WriteableReview from './WriteableReview';
import WrittenReview from './WrittenReview';
import ReviewWriteDialog from '@components/Dialog/Review/ReviewWriteDialog';

interface Props {
  reviewType: ReviewType;
}

const ReviewPresent = ({ reviewType }: Props) => {
  const classes = useStyles();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('md'));
  const history = useHistory();

  const goback = () => history.push(`/mypage`);

  return (
    <div className={classes.root}>
      {!matches && (
        <CustomizedTypography
          variant="h2"
          color="textPrimary"
          fontWeight="500"
          gutterBottoms={24}
        >
          리뷰관리
        </CustomizedTypography>
      )}

      {matches && (
        <div className={classes.header}>
          <IconButton size="small" onClick={goback}>
            <ChevronLeftOutlined />
          </IconButton>
          리뷰관리
        </div>
      )}

      <ReviewTabs />

      <ReviewWriteDialog />

      {reviewType === 'writeable' ? <WriteableReview /> : <WrittenReview />}
    </div>
  );
};

const useStyles = makeStyles(
  (theme) => ({
    root: {
      [theme.breakpoints.down('md')]: {}
    },
    header: {
      zIndex: 1010,
      height: 49,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      position: 'sticky',
      top: 0,
      padding: '12px 16px',
      borderBottom: `1px solid ${colorSet.gray400}`,
      backgroundColor: colorSet.gray000,
      '& button': {
        position: 'absolute',
        left: 16,
        width: 24,
        height: 24
      }
    }
  }),
  { classNamePrefix: 'review' }
);

export default ReviewPresent;
